import Swiper, { Navigation, Scrollbar, Autoplay } from "swiper";
import "swiper/swiper.min.css";
import "swiper/modules/scrollbar/scrollbar.min.css";

import { tablet, laptop } from "@/App/breakpoints";

import "./style.css";

export default class LatestArticles {
  static selector = ".latest_articles";

  constructor(block) {
    this.block = block;

    this.itemsContainer = this.block.querySelector(
      ".latest_articles__carousel"
    );
    this.prevButton = this.block.querySelector(".swiper-button-prev");
    this.nextButton = this.block.querySelector(".swiper-button-next");
    this.scrollbar = this.block.querySelector(".article-navigation__scrollbar");
  }

  onReady = () => {
    this.swiper = new Swiper(this.itemsContainer, {
      modules: [Scrollbar, Navigation, Autoplay],
      wrapperClass: "latest_articles__carousel-inner",
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton
      },
      slideToClickedSlide: true,
      scrollbar: {
        el: this.scrollbar,
        draggable: true,
        dragClass: "article-navigation__scrollbar-drag",
        hide: false
      },
      autoplay: {
        delay: 5000
      },
      slidesPerView: 1.333,
      spaceBetween: 24,
      //loop: true,
      breakpoints: {
        [laptop]: {
          spaceBetween: 40,
          slidesPerView: 3
        },
        [tablet]: {
          spaceBetween: 40,
          slidesPerView: 2
        }
      }
    });
  };
  onResize = () => { };
  onDestroy = () => {
    this.swiper.destroy();
  };
}
